import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Container,
    Dimmer,
    Dropdown,
    Form,
    Grid,
    Header,
    Icon,
    Loader,
    Modal,
    Segment
} from "semantic-ui-react";
import ProductList from "../../components/ProductList";
import SearchBox from "../../components/SearchBox/index";
import {
    getProducts,
    getStatus,
    getStockTakingsInProgress,
    getUnsavedChanges,
    getWarehouse,
    isInit,
    isLoading
} from "../../reducer";
import {
    find,
    init,
    loadStockTakingsInProgress,
    newSearch,
    reset,
    saveStockTaking
} from "../../reducer/actions";
import { getTranslate } from "react-localize-redux";
import { CSVLink } from "react-csv";
import { hasPermission } from "../../../../reducer";

const inlineStyle = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    form: {
        minWidth: '50vw'
    }
};

class Inventory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            account_id: 376423,
            stock_taking_id: null,
            modalOpen: {
                unsaved: false,
                dateWarning: false
            },
            download: false
        };

        props.loadStockTakings(376423);

    }

    handleOpenModal = (modal) => {
        let modalOpen = this.state.modalOpen;
        modalOpen[modal] = true;
        this.setState({modalOpen});
    };

    handleCloseModal = (modal) => {
        let modalOpen = this.state.modalOpen;
        modalOpen[modal] = false;
        this.setState({modalOpen});
    };

    findProducts(code) {
        this.props.find(code).then(()=>{
            if(this.state.download === true){
                this.setState({download: false});
            }
        });
    }

    downloadProducts(code){
        this.setState({download:true});
        this.props.find(code).then(()=>{
        });
    }

    initStockTaking() {
        this.props.init(this.state.account_id, this.state.stock_taking_id).then((stockTaking) => {
            let today = new Date();
            let date;
            if(typeof stockTaking.added.date !== 'undefined'){
                date = new Date(stockTaking.added.date);
            }else{
                date = new Date(stockTaking.added);
            }
            if (date.toDateString() !== today.toDateString()) {
                this.handleOpenModal('dateWarning')
            }

        }, (error) => {

        });
    }

    render() {
        return (
            <Container fluid style={{padding: '1em 1em'}}>
                <Grid centered>
                    <Grid.Row>
                        <Header as='h2' icon textAlign='center'>
                            <Icon name='settings' circular/>
                            <Header.Content>{this.props.translate('inventory.general.stockTaking')} {this.props.warehouse && this.props.warehouse.name}</Header.Content>
                        </Header>
                    </Grid.Row>

                    {!this.props.isInit &&
                    <Grid.Row>
                        <Segment>
                            <Form style={inlineStyle.form} loading={this.props.isLoading} onSubmit={(e) => {
                                e.preventDefault();
                                if (this.state.account_id && this.state.stock_taking_id) {
                                    this.initStockTaking();
                                }
                            }}>
                                <Form.Dropdown fluid selection options={this.props.stockTakings.sort((a,b)=>{return a.added > b.added ?  -1 : 1}).map((stockTaking)=>{
                                    return {
                                        text: stockTaking.warehouse+" - "+ (new Date(stockTaking.added)).toLocaleDateString(),
                                        value: stockTaking.stocktakingID
                                    }
                                })}

                                    value={this.state.stock_taking_id} onChange={(e, {value}) => {this.setState({stock_taking_id: value})}}
                                />

                                <Button fluid primary type='submit'>{this.props.translate('general.start')}</Button>
                            </Form>
                        </Segment>
                    </Grid.Row>
                    }

                    {(this.props.isInit && !this.props.products) &&
                    <div>
                        <Grid.Row>
                            <SearchBox loading={this.props.isLoading} callback={(code) => {
                                this.findProducts(code)
                            }}/>

                            <Modal
                                dimmer
                                basic
                                size='small'
                                style={inlineStyle.modal}
                                open={this.state.modalOpen.dateWarning}
                                onClose={() => {
                                    this.handleCloseModal('dateWarning');
                                    this.props.reset()
                                }}
                            >
                                <Header content={this.props.translate('inventory.warning.old.title')}/>
                                <Modal.Content>
                                    <p>{this.props.translate('inventory.warning.old.description')}</p>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button color='red' inverted onClick={() => {
                                        this.handleCloseModal('dateWarning');
                                        this.props.reset()
                                    }}>
                                        <Icon name='remove'/> {this.props.translate('general.cancel')}
                                    </Button>
                                    <Button color='green' inverted onClick={() => {
                                        this.handleCloseModal('dateWarning')
                                    }}>
                                        <Icon name='checkmark'/> {this.props.translate('general.confirm')}
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        </Grid.Row>
                        <Grid.Row>
                            <Dropdown button style={{marginBottom: '30px', marginTop: '30px'}} text={this.props.translate('general.options')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item text={this.props.translate('general.download')+' '+ this.props.translate('inventory.general.stockTaking')} onClick={()=>{this.downloadProducts('all')}}/>
                                    <Dropdown.Item text={this.props.translate('inventory.reports.uncounted')} onClick={()=>{this.findProducts('uncounted')}}/>
                                    {this.props.hasPermission('stockTakingAdmin') &&
                                        <Dropdown.Item
                                            text={this.props.translate('general.save') + ' ' + this.props.translate('inventory.general.stockTaking')}
                                            onClick={() => {
                                                this.props.saveStockTaking()
                                            }}/>
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </Grid.Row>
                    </div>
                    }
                    {this.props.products && !this.state.download &&
                    <div>
                        <Grid.Row>
                            <Segment>
                                {(Object.keys(this.props.unsaved).length > 0) ?
                                    <Modal
                                        dimmer
                                        trigger={<Button fluid primary onClick={() => {
                                            this.handleOpenModal('unsaved')
                                        }}>{this.props.translate('general.newSearch')}</Button>}
                                        basic
                                        size='small'
                                        style={inlineStyle.modal}
                                        open={this.state.modalOpen.unsaved}
                                        onClose={() => {
                                            this.handleCloseModal('unsaved')
                                        }}
                                    >
                                        <Header icon='close' content={this.props.translate('inventory.warning.unsaved.title')}/>
                                        <Modal.Content>
                                            <p>
                                                {this.props.translate('inventory.warning.unsaved.description')}
                                            </p>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='red' inverted onClick={() => {
                                                this.handleCloseModal('unsaved')
                                            }}>
                                                <Icon name='remove'/> {this.props.translate('general.cancel')}
                                            </Button>
                                            <Button color='green' inverted onClick={() => {
                                                this.handleCloseModal('unsaved');
                                                this.props.newSearch()
                                            }}>
                                                <Icon name='checkmark'/> {this.props.translate('general.newSearch')}
                                            </Button>
                                        </Modal.Actions>
                                    </Modal>
                                    :
                                    <Button fluid primary onClick={() => {
                                        this.props.newSearch();
                                        this.setState({download: false})
                                    }}>{this.props.translate('general.newSearch')}</Button>
                                }

                            </Segment>
                        </Grid.Row>
                        <Grid.Row textAlign='left'>
                            <Dimmer active={this.props.isLoading}>
                                <Loader/>
                            </Dimmer>
                            <ProductList products={this.props.products}/>
                        </Grid.Row>
                    </div>
                    }
                        {this.props.products && this.state.download &&
                        <div>
                            <Button fluid primary onClick={() => {
                                this.props.newSearch()
                            }}>{this.props.translate('general.newSearch')}</Button>
                            <CSVLink data={this.props.products} target="_blank" className={'ui button'} >Download</CSVLink>
                        </div>
                        }

                </Grid>
            </Container>
        );
    }
}


const mapStateToProps = state => ({
    products: getProducts(state.inventory),
    warehouse: getWarehouse(state.inventory),
    status: getStatus(state.inventory),
    isLoading: isLoading(state.inventory),
    isInit: isInit(state.inventory),
    unsaved: getUnsavedChanges(state.inventory),
    translate: getTranslate(state.localize),
    stockTakings: getStockTakingsInProgress(state.inventory),
    hasPermission: (permission)=>hasPermission(state, permission)
});

const mapDispatchToProps = (dispatch) => {
    return ({
        init: (account_id, stock_taking_id) => {
            return dispatch(init(account_id, stock_taking_id))
        },
        reset: () => {
            return dispatch(reset())
        },
        find: (code) => {
            return dispatch(find(code))
        },
        newSearch: () => {
            return dispatch(newSearch())
        },
        loadStockTakings: (account_id)=>{
            return dispatch(loadStockTakingsInProgress(account_id));
        },
        saveStockTaking: ()=>{
            return dispatch(saveStockTaking());
        }
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Inventory)



// WEBPACK FOOTER //
// ./src/scenes/Inventory/scenes/StockTaking/index.js